import {useNavigate} from 'react-router-dom';

import {CardBox} from '@shared/components';
import {ROUTE__TOPICS} from '@shared/constants';
import {Header} from '@widgets/common';
import {CreateTopicForm} from '@widgets/topic';

import {COLOR__WHITE} from '@/theme/colors';

export const CreateTopicPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header title="Create topic" mb={1} />

      <CardBox bgcolor={COLOR__WHITE}>
        <CreateTopicForm
          onCreated={() => navigate(ROUTE__TOPICS)}
          onCancel={() => navigate(-1)}
        />
      </CardBox>
    </>
  );
};
